import { APIService, ApiResponse } from './APIService';

export interface TaxRate {
  id: string;
  name: string;
  percent: number;
  venueId: string;
  partner?: string;
  partnerTaxRateId?: string;
  createdTime?: Date;
  modifiedTime?: Date;
}

class TaxService {
  /**
   * Get tax rates for a specific venue
   * @param venueId The venue ID to get tax rates for
   * @returns Promise with an array of tax rates
   */
  static async getTaxRatesByVenueId(venueId: string): Promise<TaxRate[]> {
    try {
      // Hitting the new public endpoint that does not require auth/privileges
      const response = await APIService.getData<TaxRate[]>(`tax-rates/public/by-venue/${venueId}`);

      return response.data;
    } catch (error) {
      console.error('Error fetching tax rates:', error);
      return [];
    }
  }
}

export default TaxService;
